import { render, staticRenderFns } from "./OleMissBuffersPostlabQuestion1.vue?vue&type=template&id=635e60fe&"
import script from "./OleMissBuffersPostlabQuestion1.vue?vue&type=script&lang=ts&"
export * from "./OleMissBuffersPostlabQuestion1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
